export type MenuItem = {
  label: string;
  path: string;
};

export const MENU_ITEMS: MenuItem[] = [
  { label: 'My Account', path: '/profile' },
  { label: 'My Claim History', path: '/claims' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Unleash Categories', path: '/categories' },
  { label: 'Admin', path: '/admin/dashboard' },
];
